<ng-container *ngIf="this.navigationList" class="breadcrumb">
  <div *ngIf="summaryItems?.length && isShowManageHeader">
    <app-header
      [dataRows]="summaryItems"
      [currentCompany]="currentCompany"
      (clickRow)="goToItemsWithFilter($event)"
    ></app-header>
  </div>

  <div *ngIf="summaryByVendors?.length && isShowPurchasesHeader">
    <app-header
      [dataRows]="summaryByVendors"
      [currentCompany]="currentCompany"
      [isInteraction]="false"
      (clickRow)="goToItemsWithFilter($event)"
    ></app-header>
  </div>

  <div *ngIf="currentCompany && isShowQuickFilterRecommendationHeader">
    <app-quick-filter-recommendation
    ></app-quick-filter-recommendation>
  </div>

  <div
   *ngIf="currentCompany && isShowActionCenter && !isShowQuickFilterRecommendationHeader">
    <app-action-center-manual-suggestion
    ></app-action-center-manual-suggestion>
    <app-alert-product-ads-history-logs 
    *ngIf="automationStats !== null"
    (onRestock)="onRestock()"
    (openHistoryLogs)="onOpenHistoryLogs($event)"
    (openAdsDetailLogs)="onAdsDetailLogs($event)"
    [automationStats]="automationStats"></app-alert-product-ads-history-logs>
  </div>

  <div *ngIf="(currentUser?.isAdmin || (currentCompany && !currentCompany.jobInitiator && !currentCompany.isLocked)) && !isHideBreadCrumb">
    <ng-container *ngFor="let breadcrumb of navigationList; trackBy: trackByBreadcrumb; let last = last">
      <div class="page-header breadcrumb__name" *ngIf="last && breadcrumb.breadcrumbs !== false">
        <div class="page-block">
          <div class="row align-items-center">
            <div class="col-md-12 d-flex justify-content-between">
              <div class="d-flex align-items-center">
                <div class="page-header-title d-flex align-items-center">
                  <ng-container
                    *ngFor="let breadcrumb of navigationList; let last = last"
                  >
                    <h5 class="" *ngIf="last">
                      {{ getBreadcrumbTitle((breadcrumb.mainTitle || breadcrumb.title)) }}
                    </h5>
                  </ng-container>
                </div>
                <ul class="breadcrumb align-items-center">
                  <li class="breadcrumb-item">
                    <a [routerLink]="['/dashboard/']" *ngIf="type === 'theme2'"
                      ><i class="feather icon-home"></i
                    ></a>
                    <a [routerLink]="['/dashboard/']" *ngIf="type === 'theme1'"
                      >Home</a
                    >
                  </li>
                  <ng-container *ngFor="let breadcrumb of navigationList">
                    <li class="breadcrumb-item" *ngIf="breadcrumb.url !== false">
                      <a [routerLink]="breadcrumb.url">{{ getBreadcrumbTitle(breadcrumb.title) }}</a>
                    </li>
                    <li class="breadcrumb-item" *ngIf="breadcrumb.url === false">
                      <a href="javascript:">{{ getBreadcrumbTitle(breadcrumb.title) }}</a>
                    </li>
                  </ng-container>
                </ul>
              </div>
              <div *ngIf="tourGuideUrl" class="float-right">
                <button type="button" class="btn btn-primary" (click)="modal.show()">
                  View guide
                </button>
              </div>
              <div class="d-flex align-items-center" *ngIf="isShowActionCenter || isShowQuickFilterRecommendationHeader">
                <!-- History Logs Anchor -->
                  <!-- Show Advertising Logs only on Advertising pages -->
                  <app-product-ads-history-log 
                  #productAdsHistoryLog
                    *ngIf="isShowActionCenter">
                  </app-product-ads-history-log>
                  <!-- Show Bulk History only on Repricing pages -->
                  <app-bulk-history 
                    *ngIf="isShowQuickFilterRecommendationHeader" 
                    [companyName]="currentCompany?.companyName">
                  </app-bulk-history>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</ng-container>

<app-ui-modal
  #modal
  [hideFooter]="true"
  dialogClass="w-100 custom-dialog modal-dialog-centered"
>
  <div class="app-modal-header" style="width: 100%">
    <span
      style="
        color: var(--color-text-primary);
        cursor: pointer;
        font-size: 14px;
        font-weight: bold;
        float: right;
      "
      (click)="modal.hide()"
      >X</span
    >
  </div>
  <div
    class="app-modal-body"
    style="
      position: relative;
      box-sizing: content-box;
      max-height: 80vh;
      max-height: 80svh;
      width: 100%;
      aspect-ratio: 1.421875;
    "
  >
    <iframe
      [src]="tourGuideUrl"
      title="User onboarding"
      allow="clipboard-write"
      webkitallowfullscreen="true"
      mozallowfullscreen="true"
      allowfullscreen
      style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
    ></iframe>
  </div>
</app-ui-modal>

